/**
 * Converts a Date object to a date string in format yyyy-mm-dd, which is used
 * by various HTML elements
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Date_and_time_formats#date_strings
 */
export function getHtmlDateString(date: Date): string {
  const timezoneOffset = date.getTimezoneOffset();
  const dateWithOffset = new Date(date.getTime() - timezoneOffset * 60 * 1000);
  return dateWithOffset.toISOString().split("T")[0];
}
